import api from "./auth.api";

export interface InitUploadResponse {
  uploadId: string;
  chunkSize: number;
  totalChunks: number;
}

export interface ChunkUploadResponse {
  success: boolean;
  chunkIndex: number;
}

export interface CompleteUploadResponse {
  success: boolean;
  fileId: number;
}

export interface FileInfo {
  id: number;
  filename: string;
  size: number;
  status: string;
  createdAt: string;
}

export interface UploadStatusResponse {
  exists: boolean;
  filename?: string;
  fileSize?: number;
  uploadedChunks?: number;
  totalChunks?: number;
  progress?: number;
  fileId?: number;
}

export interface VideoMetadataResponse {
  duration: number;
  title: string;
  fileSize: number;
  platform: string;
  estimatedMinutes: number;
}

export const uploadApi = {
  initUpload: async (filename: string, fileSize: number): Promise<InitUploadResponse> => {
    const response = await api.post<InitUploadResponse>("/upload/init", {
      filename,
      fileSize
    });
    return response.data;
  },

  uploadChunk: async (uploadId: string, chunkIndex: number, chunk: Blob): Promise<ChunkUploadResponse> => {
    const formData = new FormData();
    formData.append("chunk", chunk);
    formData.append("chunkIndex", chunkIndex.toString());

    const response = await api.post<ChunkUploadResponse>(`/upload/chunk/${uploadId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return response.data;
  },

  completeUpload: async (uploadId: string): Promise<CompleteUploadResponse> => {
    const response = await api.post<CompleteUploadResponse>(`/upload/complete/${uploadId}`);
    return response.data;
  },

  getFileInfo: async (fileId: number): Promise<FileInfo> => {
    const response = await api.get<FileInfo>(`/upload/file/${fileId}`);
    return response.data;
  },

  getUploadStatus: async (uploadId: string): Promise<UploadStatusResponse> => {
    const response = await api.get<UploadStatusResponse>(`/upload/status/${uploadId}`);
    return response.data;
  },

  getVideoMetadata: async (videoUrl: string): Promise<VideoMetadataResponse> => {
    const response = await api.post<VideoMetadataResponse>("/upload/video-metadata", {
      videoUrl
    });
    return response.data;
  }
};
